export default __webpack_public_path__ + "static/media/Taking an auto ride around Bandipur.7f2ff80c.jpg";